var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn back-arrow",class:{ black: _vm.black },on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('ArrowIcon'),_c('span',[_vm._v(" "+_vm._s(_vm.$t('back'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }